/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography, CardContent, Button, Grid } from '@material-ui/core';
import { CardContainer } from './other/style';
import { deleteProduct } from './other/actions';

/**
 * Component s'occupant d'afficjher les différentes informations d'un produit
 * @param {Object} product                        Objet produit
 * @param {Function} onClick   Fonction qui réalise un action quand le component est cliqué
 * @param {Function} onDelete  Fonction qui réalise un action quand le bouton rouge est cliqué
 * @param {Object} requiredAttributes                   Objet contenant les requiredAttributes renvoyer par le serveur
 */
const Product = ({ product, onClick, onDelete, requiredAttributes }) => {
  const [state] = useState({
    quantity: product.quantity,
    isInsuranceRequired: product.isInsuranceRequired
  });

  const RequiredAttributes = () => (
    <Grid container>
      {product.requiredAttributes.map(element => (
        <Grid item xs={4} md={3} key={element}>
          <Typography>
            {requiredAttributes.find(x => x.id === element).name}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <CardContainer state={{ product }}>
      <CardContent onClick={() => onClick()}>
        <Typography>Reference : {product.reference}</Typography>
        <Typography>Nom : {product.name}</Typography>
        <Typography>Code barre : {product.barcodeValue}</Typography>
        <Typography>Couleur : {product.color}</Typography>
        <Typography>Taille : {product.size}</Typography>
        <Typography>Materiel : {product.material}</Typography>
        <Typography>Quantity : {state.quantity}</Typography>
        <Typography>Pays d'origine : {product.countryOfOrigin}</Typography>
        <Typography>Valeur : {product.value} €</Typography>
        <Typography>
          Assuré pour valeur :{' '}
          {product.insuranceRequired ? 'Assuré' : 'Non Assuré'}
        </Typography>
        <Typography>A scanner lors de l'emballage : </Typography>
        {product.requiredAttributes && product.requiredAttributes.length > 0 ? (
          <RequiredAttributes requiredAttributes={product.requiredAttributes} />
        ) : (
          'Aucun'
        )}
      </CardContent>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '16px'
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={() => onDelete()}
          style={{ width: '80wh' }}
        >
          Supprimer
        </Button>
      </div>
    </CardContainer>
  );
};

const mapStateToProps = state => ({
  requiredAttributes: state.importProducts.requiredAttributes
});

const mapDispatchToProps = dispatch => ({
  dispatchDeleteProduct: data => dispatch(deleteProduct(data))
});

Product.propTypes = {
  product: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  requiredAttributes: PropTypes.array.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);
